module.exports = __webpack_public_path__ + "static/media/acba-white.288747e5.svg";